import { useEffect } from 'react';
import Bugsnag from '@bugsnag/js';
import { useBriefContext } from '../../../BriefContext';
import StartingProjectDisplay from '../../../StartingProjectDisplay/StartingProjectDisplay';
import { CollaborationStartingProjectImages } from '../../../StartingProjectDisplay/StartingProjectImages';
import { useViewContext } from '../../ViewContext';
import { useRequestWorkEntityFieldQuery } from './WorkEntityField.generated';

interface WorkEntityFieldProps {
    workEntityValue: string;
    title?: string;
    description?: string | null;
}

export default function BriefWorkEntityField(props: WorkEntityFieldProps) {
    const { correlationId } = useBriefContext();

    return <WorkEntityField {...props} correlationId={correlationId} />;
}

export function WorkEntityField(props: WorkEntityFieldProps & { correlationId: string }) {
    const { isCollaborationMode } = useViewContext();
    const { data, error } = useRequestWorkEntityFieldQuery({
        variables: {
            correlationId: props.correlationId || '',
        },
    });

    useEffect(() => {
        if (error) {
            Bugsnag.notify(new Error('unable to get preview for work entity'), (event) => {
                event.addMetadata('work-entity', {
                    errorMessage: error instanceof Error ? error.message : String(error),
                    workId: props.workEntityValue,
                });
            });
        }
    }, [error, props.workEntityValue]);

    if (error) {
        return null;
    }

    const images = data?.requestWorkEntity?.views.map((view) => ({
        url: view?._links.image.href || '',
        title: view?._links.image.title || '',
    }));

    return isCollaborationMode ? (
        <CollaborationStartingProjectImages images={images} />
    ) : (
        <StartingProjectDisplay
            images={images}
            title={props.title}
            description={props.description}
        />
    );
}
